import { InputNumber } from 'antd';
import React from 'react';
import styled from 'styled-components';

type InputProps = React.ComponentProps<typeof InputNumber>;

interface NumberFormProps {
    label?: string;
    min: InputProps;
    max: InputProps;
}

const InputNumberWrapper = styled.div<{ grid: boolean }>`
    ${({ grid }) => (grid ? `grid-column: 2 / 6;` : '')}
    .ant-input-number {
        width: 50%;
    }
`;

const NumberRangeFormGroup: React.FC<NumberFormProps> = ({ label, max, min }) => (
    <>
        {label !== undefined && (
            <div style={{ gridColumn: 1 }}>
                <strong>{label}:</strong>
            </div>
        )}
        <InputNumberWrapper grid={label !== undefined}>
            <InputNumber {...min} />
            <InputNumber {...max} />
        </InputNumberWrapper>
    </>
);

export default NumberRangeFormGroup;
